import { styled } from "goober";
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useMouseDownOutside } from "../hooks/useMouseDownOutside";
import { navigate, routes } from "../lib/urls";
import { zIndexes } from "../lib/zIndexes";
import { Icon } from "./Icon";
import { MenuItem } from "./MenuItem";
import { Text } from "./Text";

const Menu = styled("div")`
  position: fixed;
  background: var(--surface-primary);
  box-shadow: var(--elevation-high);
  outline: 0.5px solid var(--border-alpha);
  border-radius: 12px;
  padding: 4px;
  z-index: ${zIndexes.navContextMenu};
  min-width: 180px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export function NavContextMenu({
  x,
  y,
  onClose,
}: {
  x: number;
  y: number;
  onClose: () => void;
}) {
  const [containerRef, menuRef] = useMouseDownOutside(onClose);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  const left = Math.max(0, Math.min(x, window.innerWidth - 188));
  const top = Math.max(0, Math.min(y, window.innerHeight - 56));

  return createPortal(
    <div ref={containerRef} style={{ display: "contents" }}>
      <Menu
        ref={menuRef}
        data-popover
        data-direction="down"
        style={{ left, top }}
      >
        <MenuItem
          onClick={() => {
            navigate(routes.modal.customizeNav);
            onClose();
          }}
        >
          <Icon name="list-ordered" size={16} />
          <Text variant="text-regular">Customize sidebar</Text>
        </MenuItem>
      </Menu>
    </div>,
    document.body
  );
}
